import { CSSProperties } from 'react'
import ReactCarousel from '@components/common/react-carousel'

import BackgroundImageComponent from '@components/common/background-image'
import { staticFile } from '@common/utils'
import VideoPlayer from '@components/common/video-player'
import { ArrowLeft, ArrowRight } from 'react-feather'

const BackgroundImage = () => (
  <>
    <BackgroundImageComponent
      image="/images/shaastra-upskill-teacher-mentoring-program/session-recordings/left-shapes.svg"
      top={2}
      left={0}
      zIndex={0}
    />
    <BackgroundImageComponent
      image="/images/shaastra-upskill-teacher-mentoring-program/session-recordings/right-shapes.svg"
      top={2}
      right={0}
      zIndex={0}
    />
  </>
)

type CarouselComponentProps = {
  session: number
  date: string
  classes?: string
  src?: string
  poster?: string
}

const CarouselComponent = ({
  session,
  date,
  classes,
  src = '',
  poster,
}: CarouselComponentProps) => {
  return (
    <div className={`flex flex-col mx-auto my-5 lg:my-0 ${classes}`}>
      {src !== '' ? (
        <div className="px-10 lg:px-0">
          <VideoPlayer src={src} poster={poster} isVideoSourceMux />
        </div>
      ) : (
        <div
          className="relative flex justify-center px-5 mx-4 text-2xl text-white rounded-lg align-center font-400"
          style={{
            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            background:
              'radial-gradient(68.54% 289.02% at 58.96% 54.33%, #BF3240 0.68%, #7E36D9 100%), #FF5A43',
            outline: '1px solid #fff',
            outlineOffset: '-10px',
          }}
        >
          <p className="py-12 text-center lg:px-56 lg:py-32 xl:py-20 xl:px-32">
            Coming <br /> Soon
          </p>
          <img
            data-src={staticFile(
              '/images/shaastra-upskill-teacher-mentoring-program/session-recordings/pattern.svg'
            )}
            className="absolute h-32 mt-4 lazyload lg:mt-20 lg:h-40 xl:mt-4"
            alt="pattern"
          />
        </div>
      )}
      <p className="my-4">
        <span className="px-10 font-600 lg:mr-2 lg:px-0">
          Session {session}
        </span>
        {src !== '' ? (
          <></>
        ) : (
          <>
            | <span className="ml-2">Video available on {date} </span>
          </>
        )}
      </p>
    </div>
  )
}

const SessionRecordings = () => {
  const arrowStyles: CSSProperties = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 70px)',
    cursor: 'pointer',
  }

  return (
    <div className="relative my-20 mt-20">
      <BackgroundImage />
      <h2 className="px-10 py-10 pt-20 text-4xl text-center font-700 text-grey-900 lg:mx-56 lg:text-left">
        Video Session Recordings
      </h2>
      <div
        className="absolute top-0 w-full h-full lg:w-10/12 lg:left-10 rounded-2xl"
        style={{ backgroundColor: '#FFEBE5', zIndex: -10 }}
      />
      <ReactCarousel
        className="hidden px-20 lg:flex xl:flex"
        showThumbs={false}
        renderArrowPrev={(onClickHandler, hasPrev) =>
          hasPrev && (
            <div
              onClick={onClickHandler}
              style={{ ...arrowStyles, left: '0rem' }}
            >
              <ArrowLeft className="inline text-orange" size={30} />
            </div>
          )
        }
        renderArrowNext={(onClickHandler, hasNext) =>
          hasNext && (
            <div
              onClick={onClickHandler}
              style={{ ...arrowStyles, right: '2rem' }}
            >
              <ArrowRight className="inline text-orange" size={30} />
            </div>
          )
        }
        showIndicators={true}
        showStatus={false}
      >
        <div className="flex lg:space-x-20 lg:px-40">
          <CarouselComponent
            session={1}
            date="17th Jan'21"
            src="https://stream.mux.com/oMcdd00DWjHMttltpRujiX02pNqXIKh301YX8BuvrIoUJw.m3u8"
            poster="https://image.mux.com/oMcdd00DWjHMttltpRujiX02pNqXIKh301YX8BuvrIoUJw/thumbnail.png?time=1864"
          />
          <CarouselComponent
            session={2}
            date="24th Jan'21"
            src="https://stream.mux.com/C7sQpSIu14VDo00qpHSQo8xObSE1bVtHMo56Mgqs5Gzs.m3u8"
            poster="https://image.mux.com/C7sQpSIu14VDo00qpHSQo8xObSE1bVtHMo56Mgqs5Gzs/thumbnail.png?time=2386"
          />
        </div>
        <div className="flex px-40 lg:space-x-20">
          <CarouselComponent
            session={3}
            date="31st Jan'21"
            src="https://stream.mux.com/IlUit7CJdrmAkZ00nIy1RSWw2qHPZPvaAOxMUYJbYMx00.m3u8"
            poster="https://image.mux.com/IlUit7CJdrmAkZ00nIy1RSWw2qHPZPvaAOxMUYJbYMx00/thumbnail.png?time=2043"
          />
          <CarouselComponent
            session={4}
            date="1st Feb'21"
            src="https://stream.mux.com/FOZPlm025t2qGFQuMvS8KGbwQFhP3CbuWKqTTbL8djI00.m3u8"
            poster="https://image.mux.com/FOZPlm025t2qGFQuMvS8KGbwQFhP3CbuWKqTTbL8djI00/thumbnail.png?time=2442"
          />
        </div>
        <div className="flex px-40 lg:space-x-20">
          <CarouselComponent
            session={5}
            date="7th Feb'21"
            src="https://stream.mux.com/e5QRTBM00ctGNmZ901MBA00eymRLkHCvVwwu2sOLw8AYvE.m3u8"
            poster="https://image.mux.com/e5QRTBM00ctGNmZ901MBA00eymRLkHCvVwwu2sOLw8AYvE/thumbnail.png?time=2412"
          />
          <CarouselComponent
            session={6}
            date="13th Feb'21"
            src="https://stream.mux.com/Um2Bnp4ulqHkBT6PHxinAtZuRAHl8EC9A2rWzrEpNWM.m3u8"
            poster="https://image.mux.com/Um2Bnp4ulqHkBT6PHxinAtZuRAHl8EC9A2rWzrEpNWM/thumbnail.png?time=1200"
          />
        </div>
      </ReactCarousel>
      <div className="flex flex-col lg:hidden">
        <CarouselComponent
          session={1}
          date="17th Jan'21"
          src="https://stream.mux.com/oMcdd00DWjHMttltpRujiX02pNqXIKh301YX8BuvrIoUJw.m3u8"
          poster="https://image.mux.com/oMcdd00DWjHMttltpRujiX02pNqXIKh301YX8BuvrIoUJw/thumbnail.png?time=1864"
        />
        <CarouselComponent
          session={2}
          date="24th Jan'21"
          src="https://stream.mux.com/C7sQpSIu14VDo00qpHSQo8xObSE1bVtHMo56Mgqs5Gzs.m3u8"
          poster="https://image.mux.com/C7sQpSIu14VDo00qpHSQo8xObSE1bVtHMo56Mgqs5Gzs/thumbnail.png?time=2386"
        />
        <CarouselComponent
          session={3}
          date="31st Jan'21"
          src="https://stream.mux.com/IlUit7CJdrmAkZ00nIy1RSWw2qHPZPvaAOxMUYJbYMx00.m3u8"
          poster="https://image.mux.com/IlUit7CJdrmAkZ00nIy1RSWw2qHPZPvaAOxMUYJbYMx00/thumbnail.png?time=2043"
        />
        <CarouselComponent
          session={4}
          date="1st Feb'21"
          src="https://stream.mux.com/FOZPlm025t2qGFQuMvS8KGbwQFhP3CbuWKqTTbL8djI00.m3u8"
          poster="https://image.mux.com/FOZPlm025t2qGFQuMvS8KGbwQFhP3CbuWKqTTbL8djI00/thumbnail.png?time=2442"
        />
        <CarouselComponent
          session={5}
          date="7th Feb'21"
          src="https://stream.mux.com/e5QRTBM00ctGNmZ901MBA00eymRLkHCvVwwu2sOLw8AYvE.m3u8"
          poster="https://image.mux.com/e5QRTBM00ctGNmZ901MBA00eymRLkHCvVwwu2sOLw8AYvE/thumbnail.png?time=2412"
        />
        <CarouselComponent
          session={6}
          date="13th Feb'21"
          src="https://stream.mux.com/Um2Bnp4ulqHkBT6PHxinAtZuRAHl8EC9A2rWzrEpNWM.m3u8"
          poster="https://image.mux.com/Um2Bnp4ulqHkBT6PHxinAtZuRAHl8EC9A2rWzrEpNWM/thumbnail.png?time=1200"
        />
      </div>
    </div>
  )
}

export default SessionRecordings
